import { FC, ReactNode, useMemo } from 'react';
import { Box } from '@mui/material';
import useDrawer from '@/hooks/use-drawer.hook';
import { drawerMap } from './helpers';

const DrawerRoot: FC = () => {
  const { stack } = useDrawer();

  const DrawerEls: ReactNode[] = useMemo(() => {
    const lastIndex = stack.length - 1;
    const hasMultiple = stack.length > 1;

    return stack.map(({ props: drawerProps, drawerType, mounted }, index) => {
      drawerProps.isTopDrawer = hasMultiple && lastIndex === index;
      const DrawerEl = drawerMap.get(drawerType);
      if (!DrawerEl || !mounted) {
        return null;
      }
      return <DrawerEl key={`${drawerType}-${index}`} {...drawerProps} />;
    });
  }, [stack]);

  return <Box>{DrawerEls}</Box>;
};

export default DrawerRoot;
